module.exports = __webpack_public_path__ + "media/81_Long.3522d379.mp3";